module.exports = __webpack_public_path__ + "static/media/gas-board.debf4bf9.PNG";